export const HISTORY_EVENTS = {
  created: "history_created",
  updated: "history_updated",
  deleted: "history_deleted",
  sync: "history_sync",
};

export const HISTORY_CONTEXT = "history";

export const HISTORY_STORAGE_VERSION = "0.3";
